import { useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { APIURL } from "../api/config";
import useApiToken from "./useApiToken";
import { useNotification } from "../context/NotificationContext";
import { playNotificationSound } from "../utils/playNotificationSound";
export const useGlobalWindowResetAlerts = () => {
  const token = useApiToken();
  const notification = useNotification();

  useEffect(() => {
    if (!token) return;

    let connection: signalR.HubConnection | null = null;
    let isConnected = false;

    const startConnection = async () => {
      try {
        const hubBaseUrl = APIURL.replace(/\/api$/, "");
        connection = new signalR.HubConnectionBuilder()
          .withUrl(`${hubBaseUrl}/hubs/assessment`, {
            accessTokenFactory: () => token,
          })
          .withAutomaticReconnect()
          .build();

        connection.on("WindowResetRequested", (eventData: any) => {
          // Play synthesized sound
          playNotificationSound();

          // Show global toast
          notification.info(
            "Window Reset Requested",
            `Candidate ${eventData.candidateName} requested a window reset.`
          );
        });

        await connection.start();
        isConnected = true;

        // Join the global admins group
        await connection.invoke("JoinGlobalAdminGroup");
        console.log("Joined global-admins group for window reset alerts.");
      } catch (err) {
        console.error("SignalR Connection Error (Global Window Reset Alerts):", err);
      }
    };

    startConnection();

    return () => {
      if (connection && isConnected) {
        connection.stop().then(() => console.log("Global admin SignalR disconnected."));
      }
    };
  }, [token, notification]);
};
